import React from "react";
import logo from "@/assets/farma-logo.png";

export const BrandLogo = ({ className = "h-14" }) => (
  <img
    src={logo}
    alt="FARMA.STORE"
    className={className}
    style={{ objectFit: "contain" }}
    draggable={false}
    data-testid="farma-logo"
  />
);

export const BrandHeader = ({ onHome }) => (
  <header className="w-full py-4 border-b border-[var(--fs-border)] bg-white/80 backdrop-blur-sm sticky top-0 z-30">
    <div className="fs-container flex items-center justify-between">
      <button onClick={onHome} className="fs-focus rounded-lg" data-testid="header-home-button" aria-label="Home">
        <BrandLogo className="h-8 sm:h-9" />
      </button>
      <span className="fs-eyebrow text-[var(--fs-muted)]">Skin Analyzer</span>
    </div>
  </header>
);
